import React, { useState, useEffect } from 'react';
import { Col, Row, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp, faCheck, faFileDownload } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

//Helpers
import { downloadBase64File, downloadZip } from '../../../../helpers/downloadFile';

//Componentes
import TabelaListagemFichas from '../../../../components/TabelaListagemFichas/TabelaListagemFichas';

//Context
import { useAuth } from '../../../../context/auth';

function AcoesRealizadas({ acoes = [], showDivs, infracao, impressaoPDFDividaAtiva }) {
    //Estado de controle de exibição dos valores dos cards
    const [showContent, setShowContent] = useState({});

    const { setLoading, session } = useAuth();

    const onClickTimeLine = (index) => {
        setShowContent({
            ...showContent,
            [index]: !showContent[index]
        })
    }

    //Cabeçalhos da lista de consulta infração
    const headersVotocao = [
        { value: "Usuário", objectValue: "usuario", align: "left" },
        { value: "Voto", objectValue: "voto", align: "left" },
        { value: "Data/Hora", objectValue: "dataHora", align: "left", formatDate: true },
        { value: "Observação", objectValue: "observacoes", align: "left" },
    ];

    useEffect(() => {
        if (acoes && acoes.length > 0) {
            setLoading(true);
            const _showContent = {};
            acoes.map((value, index) => {
                _showContent[index] = showDivs;
            })
            setShowContent(_showContent);
            setLoading(false);
        }
    }, [showDivs]);

    // Pré-computa o índice de cada boleto no array de ações, usando fiscalizacaoInfracaoAcao_Id
    const boletosIndexados = (infracao?.boletos ?? []).map(boleto => ({
        ...boleto,
        acaoIndex: acoes.findIndex(a => a.id === boleto.fiscalizacaoInfracaoAcao_Id)
    }));

    const statusNaoVigente = ["Vencido", "Cancelado", "Registrado"];

    return <>
        {acoes?.map((acao, key) => (
            <div key={key} style={{ position: "relative" }} className='contentGroup mt-4 shadowFicha rounded-3'>
                <div className='text-white pointHistory d-lg-flex d-md-none noPrint'>
                    <FontAwesomeIcon size='xs' icon={faCheck} />
                </div>
                <h5 role='button' onClick={() => onClickTimeLine(key)} className={`m-0 p-2 titleFicha ${showContent[key] || !!impressaoPDFDividaAtiva ? "mb-2" : "close"} d-flex justify-content-between align-items-center`} >
                    <span>
                        {acao.situacaoInfracao} - <span style={{ fontSize: "12pt", color: "#999" }}>{acao?.dataHora ? moment(acao?.dataHora).format("DD/MM/YYYY HH:mm") : ""}</span>
                    </span>
                    <span className='noPrint'>
                        <FontAwesomeIcon icon={showContent[key] || !!impressaoPDFDividaAtiva ? faAngleUp : faAngleDown} />
                    </span>
                </h5>
                <div className={`cardContainer ${showContent[key] || !!impressaoPDFDividaAtiva ? "" : "close"}`}>
                    <Row className='px-3 py-0'>
                        {session && !!acao?.acaoVotacoes?.length == 0 &&
                            <Col md="12" lg="6" className='mb-1'>
                                <span className="fw-bold">Responsável: </span> {acao?.usuario_Nome}
                            </Col>
                        }
                        {infracao?.numeroProcessoInterno &&
                            <Col md="12" lg="6" className='mb-1'>
                                <span className="fw-bold">Número do processo interno: </span> {infracao?.numeroProcessoInterno}
                            </Col>
                        }
                        {!!acao?.observacoes &&
                            <Col md="12" lg="12" className='mb-1'>
                                <span className="fw-bold">Observaçoes: </span> {acao.observacoes}
                            </Col>
                        }
                    </Row>
                    {acao?.acaoVotacoes?.length > 0 &&
                        <Row className='px-3 py-0'>
                            <TabelaListagemFichas
                                options={{ print: false, search: true, pagination: true }}
                                headers={headersVotocao}
                                items={acao.acaoVotacoes}
                            />
                        </Row>
                    }
                    {(() => {
                        const boletosVisiveis = boletosIndexados.filter(boleto => {
                            // Oculta boletos irrelevantes para sessão pública
                            if (session == null && (boleto.status === "Cancelado" || boleto.status === "Registrado"))
                                return false;

                            // A ação que gerou este boleto deve existir no fluxo
                            if (boleto.acaoIndex === -1) return false;

                            // Exibe da etapa de emissão em diante (vigentes e vencidos)
                            return key >= boleto.acaoIndex;
                        });

                        if (boletosVisiveis.length === 0) return null;

                        return (
                            <>
                                <Row className='px-3 py-0'>
                                    <Col md="12" lg="12" className='mb-1'>
                                        <h5 className="fw-bold m-0">Boleto{boletosVisiveis.length > 1 ? "s" : ""}</h5>
                                    </Col>
                                </Row>
                                {boletosVisiveis.map((value, index) => (
                                    <Row className='px-3' key={index}>
                                        <Col md="12" lg="6" className='mb-2'>
                                            <span className="fw-bold">Valor: </span> {`R$ ${value?.valor.toFixed(2).replace(".", ",")}`}
                                        </Col>
                                        <Col md="12" lg="6" className='mb-2'>
                                            <span className="fw-bold">Status: </span> {value?.status}
                                        </Col>
                                        <Col md="12" lg="6" className='mb-2'>
                                            <span className="fw-bold">Data de Criação: </span> {moment(value?.dataEmissao).format("DD/MM/YYYY")}
                                        </Col>
                                        <Col md="12" lg="6" className='mb-2'>
                                            <span className="fw-bold">Data de Vencimento: </span> {moment(value?.dataVencimento).format("DD/MM/YYYY")}
                                        </Col>
                                        <Col md="12" lg="4" className='mb-2'>
                                            <Button
                                                outline
                                                color={statusNaoVigente.includes(value.status) ? "danger" : "success"}
                                                onClick={() => downloadBase64File(value.arquivo, "boletoFISCSP")}
                                            >
                                                <FontAwesomeIcon icon={faFileDownload} />
                                                <span className="ms-2">Boleto {value.status}</span>
                                            </Button>
                                        </Col>
                                    </Row>
                                ))}
                            </>
                        );
                    })()}

                    {acao?.documentos.length > 0 ?
                        <Row className='px-3 py-0'>
                            <Col md="12" lg="12" className='mb-1' >
                                <h5 className="fw-bold m-0" >Documentos </h5>
                            </Col>
                        </Row> : ""
                    }

                    {acao?.documentos?.map((d, ke3) => (
                        <Row className='px-3 py-1 ' key={ke3}>
                            <div className='d-flex align-items-center justify-content-start flex-wrap gap-3 mb-2'>
                                <Button
                                    outline
                                    color={"secondary"}
                                    onClick={() => {
                                        const extensao = d?.arquivo?.split('.').pop()?.toLowerCase();
                                        if (extensao === "zip")
                                            downloadZip(d.base64, d.linkArquivo)
                                        else
                                            downloadBase64File(d.base64, d.identificacaoDocumento);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faFileDownload} />
                                    <span className="ms-2">{d.identificacaoDocumento}</span>
                                </Button>
                            </div>
                        </Row>
                    ))}

                    <Row className='px-3 py-0'>
                        {acao?.formulario.length > 0 ?
                            <Col md="12" lg="12" className='mb-2'>
                                <h5 className="fw-bold m-0" >Formulário </h5>
                            </Col> : ""
                        }
                        {acao?.formulario?.map((f, key2) => (
                            <Col md="12" lg="12" className='mb-2' key={key2}>
                                <span className="fw-bold">{f.questao}: </span> {f?.resposta}
                            </Col>
                        ))}
                    </Row>
                    <Row className='px-3 py-0'>
                        {!!acao?.acaoIdentificacao &&
                            <Col md="12" lg="12" className='mb-1'>
                                <span className="fw-bold">Resposta: </span> {acao?.acaoIdentificacao}
                            </Col>
                        }
                    </Row>
                </div>
            </div>
        ))}
    </>;
}

export default AcoesRealizadas;